import React, { memo } from 'react';

const LiteralsIcon = ({ color = '#335B70', ...props }) => (
    <svg {...props} viewBox="0 0 32 32">
        <path
            fill={color}
            d="M7.802 16l5.532 15.999h-2.65l-1.195-3.725h-5.662l-1.185 3.725h-2.64l5.522-15.999h2.279zM23.445 18.203l1.211 1.236-5.507 5.618 2.678 0.002v1.736h-5.603v-5.697h1.719l0.002 2.714 5.499-5.609zM6.667 18.909l-2.222 7.272h4.444l-2.222-7.272zM26.456 0.001c1.69 0 2.977 0.363 3.86 1.088s1.324 1.806 1.324 3.242c0 0.733-0.185 1.392-0.554 1.978s-0.91 1.040-1.622 1.363c0.808 0.234 1.432 0.676 1.873 1.324s0.662 1.427 0.662 2.335c0 1.502-0.45 2.656-1.35 3.461s-2.188 1.209-3.865 1.209h-5.451v-15.999h5.123zM17.391 5.205v5.697h-1.719l-0.002-2.714-5.499 5.609-1.212-1.236 5.508-5.618-2.678-0.002v-1.736h5.603zM27.031 8.781h-3.1v5h2.885c0.815 0 1.451-0.216 1.909-0.648s0.688-1.033 0.688-1.802c0-1.663-0.794-2.513-2.382-2.549zM26.456 2.242h-2.525v4.494h2.546c0.808 0 1.439-0.196 1.894-0.588s0.683-0.947 0.683-1.665c0-0.791-0.21-1.363-0.631-1.714s-1.076-0.527-1.966-0.527z"
        />
    </svg>
);

export default memo(LiteralsIcon);
